<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('homePage.homeworkApproval') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label
                class="col-form-label control-label"
                :class="{ required: app_status_id == 2 }"
                >{{ $t('homePage.reason') }}</label
              >
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.app_comment"
                  :class="{ 'is-invalid': errors.has('app_comment') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('app_comment')">
                  {{ errors.first('app_comment') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="changeApprovalStatus"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['app_status_id', 'data'],
  name: 'reasonForm',
  data() {
    return {
      model: {
        requester_id_list: [],
        app_type_id: null,
        app_status_id: null,
        app_comment: null
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.model.requester_id_list = [this.data.request_id]
      this.model.app_type_id = this.data.app_type_id
      this.model.app_status_id = this.app_status_id
      this.model.app_comment = this.data.approved_comments
    },
    changeApprovalStatus() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('home/staffMyApproval/changeApprovalStatus', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.$store.commit('home/staffMyApproval/RESET_STATE')
          this.$store.commit('home/staffMyApproval/SET_APPROVE_STATUS', '')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
